import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const API_URL =
    process.env.REACT_APP_API_URL ||
    "https://mv-tyre.demo-customproject.com/backend/api/";

/* ---------------------- PAYMENT ASSIST (PAY IN 3) ------------------------ */

const PaymentAssist = ({ total, orderNumber, orders }) => {
    const [loading, setLoading] = useState(false);

    const shipping = 9.99;
    const safeSubtotal = Number(total || 0);
    const safeTotal = safeSubtotal + shipping; // subtotal + shipping
    const installment = (safeTotal / 3).toFixed(2);

    const [form, setForm] = useState({
        full_name: `${orders?.fname || orders?.first_name || ""} ${orders?.lname || orders?.last_name || ""
            }`,
        email: orders?.email || "",
        phone: orders?.phone || "",
        address: orders?.address1 || "",
        dob: "", // HTML date input: YYYY-MM-DD
    });

    const handleAssitIn = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const submitAssist = async () => {
        if (!form.dob) {
            toast.error("Enter your Date of Birth");
            return;
        }

        // full_name ko first_name / last_name me tod do
        let firstName = orders?.fname || orders?.first_name || "";
        let lastName = orders?.lname || orders?.last_name || "";

        if (form.full_name && form.full_name.trim().length > 0) {
            const parts = form.full_name.trim().split(" ");
            firstName = parts[0];
            lastName = parts.slice(1).join(" ") || parts[0];
        }
        setLoading(true);
        try {
            const res = await axios.post(`${API_URL}payment-assist/create`, {
                order_number: orderNumber,
                amount: safeTotal, // backend pence me convert karega
                first_name: firstName,
                last_name: lastName,
                address_line_1: form.address || orders.address1,
                address_line_2: orders.address2,
                town: orders.town,
                county: orders.state,
                postcode: orders.zip,
                email: form.email || orders.email,
                phone: form.phone || orders.phone,
                dob: form.dob,
            });

            if (res.data?.status && res.data?.data?.redirect_url) {
                toast.success("Redirecting to Payment Assist...");
                window.location.href = res.data.data.redirect_url;
            } else {
                toast.error(
                    res.data?.message || "Unable to start Payment Assist session"
                );
            }
        } catch (err) {
            console.error("Payment Assist Error:", err);
            const apiError = err.response?.data;
            const telephoneError =
                apiError?.errors?.data?.telephone ||
                apiError?.errors?.data?.phone;
            toast.error(
                telephoneError ||
                apiError?.message ||
                "Payment Assist error"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="payment-card fadeArea">
            <h2 className="payment-title">Pay in 3 Monthly Installments</h2>
            <p className="payment-amount">
                Total (incl. delivery):{" "}
                <strong>£{safeTotal.toFixed(2)}</strong>
            </p>
            <p className="installment-txt">
                You will pay <strong>£{installment}</strong> per month for 3
                months.
            </p>

            <div className="row">
                <div className="col-lg-6">
                    <label>Enter Your Name</label>
                    <input
                        type="text"
                        name="full_name"
                        placeholder="FULL NAME"
                        value={form.full_name}
                        onChange={handleAssitIn}
                        className="pay-input"
                    />
                </div>
                <div className="col-lg-6">
                    <label>Enter Your Email</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="EMAIL ADDRESS"
                        value={form.email}
                        onChange={handleAssitIn}
                        className="pay-input"
                    />
                </div>
                <div className="col-lg-12">
                    <label>Enter Your Address</label>
                    <input
                        type="text"
                        name="address"
                        placeholder="ADDRESS"
                        value={form.address}
                        onChange={handleAssitIn}
                        className="pay-input"
                    />
                </div>
                <div className="col-lg-6">
                    <label>Enter Your Number</label>
                    <input
                        type="text"
                        name="phone"
                        placeholder="PHONE NUMBER"
                        value={form.phone}
                        onChange={handleAssitIn}
                        className="pay-input"
                    />
                </div>
                <div className="col-lg-6">
                    <label>Enter Your DOB</label>
                    <input
                        type="date"
                        name="dob"
                        className="pay-input"
                        value={form.dob}
                        onChange={handleAssitIn}
                    />
                </div>
            </div>

            <button
                className="theme-btn modern-btn"
                onClick={submitAssist}
                disabled={loading}
            >
                {loading ? "Processing..." : "Continue to Payment Assist"}
            </button>
        </div>
    );
};

/* --------------------------- MAIN PAYMENT MODAL -------------------------- */

const Payment = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { cart, orders, total, orderNumber } = location.state || {};

    useEffect(() => {
        if (!location.state) navigate("/checkout");
    }, [location.state, navigate]);

    if (!cart || !orders || !total || !orderNumber) {
        return null;
    }

    return (
        <div className="payment-popup-container">
            <div className="payment-wrapper">
                <PaymentAssist
                    total={total}
                    cart={cart}
                    orders={orders}
                    orderNumber={orderNumber}
                />
            </div>
        </div>
    );
};

export default Payment;
